{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".brands__logos");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          speed: 1500,
          slidesPerView: "auto",
          spaceBetween: 64,
          loop: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
          effect: "slide",
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              spaceBetween: 30,
            },
            768: {
              spaceBetween: 40,
            },
            1024: {
              spaceBetween: 64,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
